module.exports = __webpack_public_path__ + "static/fonts/AmwayIcons.75de32d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/self-diagnosis/font/AmwayIcons.ttf?5v2gxx
// module id = a0dS
// module chunks = 0